import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { CouponService } from "app/services";
import { PagedReservationsList } from "app/types/service-types/ReservationTypes";

interface CouponReservationsState {
  loading: boolean;
  page: PagedReservationsList | null;
}

const initialState: CouponReservationsState = {
  loading: false,
  page: null,
};

const couponReservationsSlice = createSlice({
  name: "coupons/reservations",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setCouponReservations(state, action: PayloadAction<PagedReservationsList>) {
      state.page = action.payload;
    },
  },
});

export const { setLoading, setCouponReservations } =
  couponReservationsSlice.actions;

export const fetchCouponReservations =
  (params?: { page?: number; size?: number; couponCode?: string }) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await CouponService.getReservationsWithCoupon(
        params ?? {}
      );
      dispatch(setCouponReservations(response));
    } finally {
      dispatch(setLoading(false));
    }
  };

export default couponReservationsSlice.reducer;
